import type {Prize} from 'services/prizes/types';

export const isPrizeValue = (value: unknown): value is Prize =>
  typeof value === 'object' && (value as Prize).winners != null;
